import React from 'react';

const Modal = ({ onClose, totalEarnings, totalReservations, arrivedGuests, noShows }) => {
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-MA', {
            style: 'currency',
            currency: 'MAD',
            maximumFractionDigits: 2
        }).format(amount);
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 transition-opacity duration-300 ease-in-out">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl animate-fade-in">
                <div className="border-b border-gray-200 p-6">
                    <h1 className="text-3xl font-bold text-[#610c63] text-center">Day Complete!</h1>
                    <p className="text-gray-600 text-center mt-2">Here's your summary for today</p>
                </div>

                <div className="p-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        <div className="text-center p-6 bg-purple-50 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                            <p className="text-sm text-gray-500 mb-2">Total Earnings</p>
                            <p className="text-3xl font-bold text-[#610c63]">{formatCurrency(totalEarnings)}</p>
                        </div>

                        <div className="text-center p-6 bg-purple-50 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                            <p className="text-sm text-gray-500 mb-2">Total Reservations</p>
                            <p className="text-3xl font-bold text-[#610c63]">{totalReservations}</p>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                        <div className="text-center p-6 bg-green-50 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                            <p className="text-sm text-gray-500 mb-2">Arrived Guests</p>
                            <p className="text-3xl font-bold text-green-600">{arrivedGuests}</p>
                        </div>

                        <div className="text-center p-6 bg-red-50 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                            <p className="text-sm text-gray-500 mb-2">No Shows</p>
                            <p className="text-3xl font-bold text-red-600">{noShows}</p>
                        </div>
                    </div>

                    <div className="text-center mt-8">
                        <button
                            onClick={onClose}
                            className="bg-[#610c63] text-white px-8 py-3 rounded-lg hover:bg-[#4a0a4c] transition-colors duration-300 text-lg font-semibold w-full md:w-auto"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
